<template>
  <NuxtLayout name="catalog">
    <div class="page-container pb-10">
      <MoleculesGlobalBreadcrumb class="my-6" :segments="[{ text: (i18n.t('Výsledky hledání pro dotaz') + ` &quot;${searchText}&quot;`), url: route.fullPath }]"></MoleculesGlobalBreadcrumb>
      <AtomsTextHeader class="header--with-line">{{ $t('Výsledky hledání') }} "{{ searchText }}"</AtomsTextHeader>
      {{ $t('Pokud jsme našli příliš mnoho výsledků, zkuste dotaz konkretizovat. Pokud jsme naopak nic nenašli, zkuste váš dotaz zobecnit.') }}
      <div v-if="numOfResults > 0 && searchText.length > 2">
        <div v-if="searchResults?.groups?.count" class="grid grid-cols-1 xl:grid-cols-4 gap-8 my-12">
          <MoleculesBlocksSubGroupItem v-for="item in searchResults.groups.items" :id="item.id" :name="item.name" :full-name="item.page.title" :url="item.page.url" />
        </div>
        <div v-if="searchResults?.wares?.count">
          <div class="lg:hidden uppercase text-gray mt-8">{{ $t('Produkty') }}</div>
          <div class="mt-6">
            <OrganismsListsWareList :items="items" :page-size="appConfig.wareList.itemsOnPage" :page="page" :total-items="searchResults?.wares?.count" list-name="Výsledky hledání" />
          </div>
        </div>
        <div v-if="searchResults?.infoPages?.count">
          <div class="uppercase text-gray mb-4 mt-8">{{ $t('Články') }}</div>
          <div v-for="item in searchResults.infoPages.items" class="mb-4">
            <AtomsGlobalLink :to="item.page.url">{{ item.page.title }}</AtomsGlobalLink>
          </div>
        </div>
      </div>
      <div v-if="searchText.length <= 2" class="text-xl text-gray">
        {{ $t('Zadejte text pro vyhledání') }}
      </div>
      <div v-if="searchText.length > 2 && numOfResults === 0">
        <TemplatesNotFound />
      </div>
    </div>
  </NuxtLayout>
</template>
<script setup>

const route = useRoute();
const locale = useLocale().getLocale();
const i18n = useI18n();
const shopRouting = useShopRouting();
const appConfig = useAppConfig();
const analytics = useAnalytics();

const searchText = route.query.q;

const searchResults = (await useApiFetch(`/api/search?phrase=${encodeURIComponent(searchText)}&currencyId=${locale.currencyId}&languageId=${locale.languageId}`)).data.value.search;

analytics.pushEvent('search', {
  search_term: searchText,
  search_type: 'fulltext',
  search_results: searchResults.wares?.count + searchResults.groups?.count + searchResults.infoPages?.count,
  search_results_products: searchResults.wares?.count,
  search_results_groups: searchResults.groups?.count,
  search_results_articles: searchResults.infoPages?.count
});

const items = ref(searchResults.wares.items);

const numOfResults = computed(() => searchResults.groups?.count + searchResults.infoPages?.count + searchResults.wares?.count);

const hash = ref(shopRouting.parseHash());
const page = ref(1);

const processSpecificFetch = async (url, query) => {
  const fn = process.server ? useApiFetch : $fetch;

  const response = await fn(url, { query: query });

  if (process.server) {
    return response;
  }
  else {
    return response.search;
  }
}

// reload items when the query changes and also when the initial load contains some parameters for filtering, sorting or paging
watch(() => route.hash, async () => {

  hash.value = shopRouting.parseHash();

  const pageParameter = hash.value.find(q => q.key === 'p')?.value.toString() ?? "1";
  const pageNumber = parseInt(pageParameter.split('-')[0]);
  const append = pageParameter.split('-').length === 2 && pageParameter.split('-')[1] === 'a';

  page.value = pageNumber;

  const updatedData = await processSpecificFetch(`/api/search?phrase=${encodeURIComponent(searchText)}&currencyId=${locale.currencyId}&languageId=${locale.languageId}&p=${pageNumber}`);

  if (append) {
    items.value = items.value.concat(updatedData.wares.items);
  }
  else {
    items.value = updatedData.wares.items;
  }

}, { flush: 'pre', immediate: hash.value.length > 0, deep: false });

</script>